// extracted by mini-css-extract-plugin
export default {"root":"WorkExperience_root__aK0jn","inner":"WorkExperience_inner__SPwFJ","onlyMobile":"WorkExperience_onlyMobile__sOakg"};